import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, Teleport as _Teleport, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5083f520"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card_text_and_image_wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "list-disc pl-5 mt-4 space-y-1" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Operatör:"),
    /*#__PURE__*/_createTextVNode(" Deutsche Bahn (DB)")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Snabbtåg:"),
    /*#__PURE__*/_createTextVNode(" ICE, IC, EC")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Regionaltåg:"),
    /*#__PURE__*/_createTextVNode(" RE, RB, S-Bahn")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Biljettinformation:"),
    /*#__PURE__*/_createTextVNode(" Billiga biljetter via “Sparpreis” om du bokar tidigt ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Resebokning:"),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.bahn.de",
      target: "_blank",
      class: "text-blue-600 underline"
    }, "bahn.de")
  ])
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "list-disc pl-5 space-y-1" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Planera:"),
    /*#__PURE__*/_createTextVNode(" Kolla tidtabeller och platsbokningar för ICE-tåg. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Budget:"),
    /*#__PURE__*/_createTextVNode(" Mat och logi är generellt prisvärda utanför storstäderna. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Språk:"),
    /*#__PURE__*/_createTextVNode(" Engelska fungerar bra i städer, men tyska fraser uppskattas. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Regionbiljetter:"),
    /*#__PURE__*/_createTextVNode(" Länderbiljetter (t.ex. “Bayern Ticket”) är prisvärda för regionaltåg. ")
  ])
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "list-disc pl-5 space-y-1" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.bahn.de",
      target: "_blank",
      class: "text-blue-600 underline"
    }, "Deutsche Bahn – Officiell webbplats")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.interrail.eu/en/plan-your-trip/trip-ideas/germany",
      target: "_blank",
      class: "text-blue-600 underline"
    }, "Interrail – Tyskland")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.rome2rio.com",
      target: "_blank",
      class: "text-blue-600 underline"
    }, "Rome2Rio – reseplanering")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.germany.travel",
      target: "_blank",
      class: "text-blue-600 underline"
    }, "Germany.travel – Officiell turism")
  ])
], -1))

import TextBlock from "../../blocks/TextBlock.vue";
import ContentWrapper from "../../generics/ContentWrapper.vue";
import PageTitle from "../../blocks/PageTitle.vue";
import Breadcrumbs from "@/components/generics/BreadCrumbs.vue";
import GridCard from "../GridCard.vue";
import ListCard from "../ListCard.vue";
import meta from "@/data/meta.json";

export default /*#__PURE__*/_defineComponent({
  __name: 'GermanyGuide',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      (_openBlock(), _createBlock(_resolveDynamicComponent('script'), { type: "application/ld+json" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(meta).germanyGuide), 1)
        ]),
        _: 1
      }))
    ])),
    _createVNode(PageTitle, {
      text: "Tyskland",
      "text-color": "black",
      "border-color": "black",
      maxHeight: "60vh",
      backgroundImageClass: "background-germany"
    }),
    _createVNode(ContentWrapper, { showBreadcrumbs: true }, {
      default: _withCtx(() => [
        _createVNode(Breadcrumbs),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(TextBlock, { header: "Upptäck Tyskland med tåg" }, {
            default: _withCtx(() => [
              _createTextVNode(" Tyskland är ett perfekt land för tågluffare - stort, varierat och med ett av Europas mest omfattande järnvägsnät. Här väntar allt från medeltida småstäder till moderna metropoler, från sagolika slott till pulserande nattliv och böljande vinlandskap. Tågen går ofta, snabbt och punktligt. ")
            ]),
            _: 1
          }),
          _createVNode(TextBlock, { header: "Att resa med tåg i Tyskland" }, {
            default: _withCtx(() => [
              _createTextVNode(" Det tyska tågnätet drivs främst av Deutsche Bahn (DB), men kompletteras av flera regionala operatörer. Interrailkort gäller på nästan alla tåg, men vissa snabbtåg kräver platsreservation. "),
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(ListCard, {
            title: "Förslag på tågrutter i Tyskland",
            items: [
					{
						title: 'Klassiska Tysklandsresan',
						description: 'Berlin → Leipzig → München → Nürnberg',
						link: '',
					},
					{
						title: 'Romantikrutten',
						description: 'Heidelberg → Rothenburg ob der Tauber → Füssen',
						link: '',
					},
					{
						title: 'Alpresan',
						description: 'München → Garmisch-Partenkirchen → Berchtesgaden',
						link: '',
					},
					{
						title: 'Nord till syd',
						description: 'Hamburg → Hannover → Frankfurt → Freiburg',
						link: '',
					},
				]
          }),
          _createVNode(GridCard, {
            title: "Destinationer i Tyskland",
            items: [
					{
						title: 'Berlin',
						image: '🧱',
						description:
							'Historia, klubbkultur och kreativ energi i huvudstaden.',
						link: '/guider/destinationer/tyskland/berlin',
					},
					{
						title: 'München',
						image: '🍺',
						description:
							'Öl, Alper och bayersk charm – särskilt under Oktoberfest.',
						link: '/guider/destinationer/tyskland/munchen',
					},
					{
						title: 'Hamburg',
						image: '⚓',
						description:
							'Hamn, alternativkultur och en av Europas största musikscener.',
						link: '/guider/destinationer/tyskland/hamburg',
					},
					{
						title: 'Heidelberg',
						image: '🏰',
						description: 'Romantisk universitetsstad vid floden Neckar.',
						link: '/guider/destinationer/tyskland/heidelberg',
					},
					{
						title: 'Freiburg',
						image: '🌲',
						description:
							'Grön stad vid foten av Schwarzwald, perfekt för vandring.',
						link: '/guider/destinationer/tyskland/freiburg',
					},
					{
						title: 'Dresden',
						image: '🎨',
						description: 'Barockens pärla med konst, flodutsikt och historia.',
						link: '/guider/destinationer/tyskland/dresden',
					},
				]
          }, null, 8, ["items"]),
          _createVNode(TextBlock, { header: "Tips för tågluffare i Tyskland" }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(TextBlock, { header: "Resurser" }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})